export default "__VITE_ASSET__f1bfac6c__"